export enum PublicImage {
  ZohoIntegration = 'zoho/zoho-integration.svg',
}
